<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer></v-spacer>
      <toolbar-inline>
        <v-checkbox
            label="取引先のみ表示"
            v-model="showSelected">
        </v-checkbox>
      </toolbar-inline>
      <toolbar-inline>
        <trade-contract-filter
            @apply-filter="tradeContractFilter = $event"
            hide-status-filters
            hide-direction-filters>
        </trade-contract-filter>
      </toolbar-inline>
      <toolbar-inline>
        <v-text-field
            v-model="filterText"
            clearable
            placeholder="検索">
        </v-text-field>
      </toolbar-inline>
    </template>

    <el-table
        :data="tradeContractsViewFiltered"
        :default-sort="{prop: 'expireDate', order: 'ascending'}"
        border>
      <el-table-column
          width="250"
          prop="name"
          label="取引契約名"
          fixed="left"
          :sort-method="buildSort(row => row.name)"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.name"
                :value-id="row.id">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="80"
          label="区分"
          align="center"
          prop="serviceTypeText"
          sortable>
      </el-table-column>

      <el-table-column
          min-width="200"
          label="データ構成モデル名"
          prop="tradeContractSource.dataComponentModelName"
          :sort-method="buildSort(row => row.tradeContractSource.dataComponentModelName)"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.tradeContractSource.dataComponentModelName"
                placeholder="未選択">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          min-width="150"
          prop="companionOwnerName"
          label="取引先事業者"
          sortable>
        <template #default="{row}">
          <table-inline v-if="row.companionTerminalName">
            <text-field-like
                style="font-size: 85%;"
                :value="row.companionTerminalName">
            </text-field-like>
          </table-inline>
          <table-inline>
            <text-field-like
                :value="row.companionOwnerName"
                placeholder="相手側で未承認">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="120"
          label="申込期限"
          prop="expireDate"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
              :value="formatDate(row.expireDate)"
              placeholder="未設定">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="70"
          align="center"
          fixed="right"
          column-key="editing">
        <template #default="{row}">
          <icon-btns>
            <icon-btn
                type="view"
                :to="{name: '/profileSearch/publicTradeContracts/browse', params: {tradeContractId: row.id}}">
            </icon-btn>
          </icon-btns>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {SERVICE_TYPES} from "@/constants";
import {mapGetters, mapMutations} from "vuex";
import TradeContractView, {createTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import IoablePageMixin from "@/router/IoablePageMixin";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TradeContractFilter from "@/components/organisms/TradeContractFilter.vue";
import Formatter from "@/utils/Formatter";
import ToolbarInline from "@/components/atoms/ToolbarInline.vue";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import PageStoreMixin, {mapPageStores} from "@/utils/PageStoreMixin";
import {DateTime} from "luxon";
export default {
  name: "PublicTradeContractTab",
  components: {ToolbarInline, TradeContractFilter, IconBtn, IconBtns, TextFieldLike, TableInline, TabItemTemplate},
  mixins: [
    IoablePageMixin,
    Formatter,
    TableUtil,
    PageStoreMixin
  ],
  data() {
    return {
      tradeContractFilter: () => true,
      filterText: '',
      serviceTypes: SERVICE_TYPES,
      tradeContracts: []
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    ...mapPageStores({
      showSelected: {alt: false} // 取引先のみ表示
    }),
    tradeContractsView() {
      const now = DateTime.now();
      return this.tradeContracts
          .filter(tc => tc.expireDate >= now)
          .filter(this.tradeContractFilter);
    },
    tradeContractsViewFiltered() {
      const f = this.filterText;
      if(f) {
        return this.tradeContractsView.filter(tc =>
            tc.id.includes(f) ||
            tc.name.includes(f) ||
            tc.tradeContractSource.dataComponentModelName?.includes(f) ||
            tc.companionOwnerName?.includes(f)
        );
      } else {
        return this.tradeContractsView;
      }
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    async load() {
      this.tradeContracts = [];
      const {data: tradeContracts} = await this.hcsClient.get('/assets/trade_contracts', {params: {
          'q[status_eq]': 'public',
          isCustomer: this.showSelected
        }});
      this.tradeContracts = tradeContracts
          .map(tc => createTradeContractView(tc, this.$store))
          .filter(tc => tc.otherTerminalId !== this.account?.user.terminalId);
    },
  },
  watch: {
    showSelected: {
      handler(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.doLoad();
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
